import config from "@/lib/config";
import { maskTargetKeys, metaSchemas, userRating } from "@/lib/constants";
import getRemoteIpAddress from "@/lib/getRemoteIpAddress";
import { RESTDataSource } from "@apollo/datasource-rest";
import { v4 as uuidv4 } from "uuid";

function recurciveMask(data = {}) {
  const copiedData = JSON.parse(JSON.stringify(data));
  function mask(key, value) {
    if (Array.isArray(value)) {
      return value.map((v) => mask(key, v));
    } else if (typeof value === "object") {
      return recurciveMask(value);
    } else if (typeof value === "string") {
      if (maskTargetKeys.includes(key)) {
        return value.replace(/./g, "*");
      } else {
        return value;
      }
    }
    return value;
  }
  for (const key in copiedData) {
    const value = copiedData[key];
    copiedData[key] = mask(key, value);
  }
  return copiedData;
}

class LogicaAPI extends RESTDataSource {
  baseURL = config.api.vcmsURL;

  constructor(options) {
    super(options);
    this.context = options;
  }

  get config() {
    return {
      service: config.service,
      deviceCode: this.context.req.deviceCode,
      appId: config.appId["vod"],
      storeId: config.storeId["vod"],
      valuePlanId: config.valuePlanId["vod"],
      userId: this.context.req?.userToken?.id,
      profileId: this.context.req?.userToken?.currentProfile,
      rating: this.context.req?.userToken?.rating,
    };
  }

  get dsearchCommonParams() {
    return {
      service: this.config.service,
      device_code: this.config.deviceCode,
      app_id: this.config.appId,
      datasource: "decorator",
    };
  }

  get dsearchCommonCondition() {
    const condition = {
      "values.adult_flag": false,
    };
    if (this.isMaybeLoggedIn() && typeof this.config.rating === "number") {
      condition["values.rating"] = userRating[this.config.rating].permitRating;
    }
    return condition;
  }

  dsearchContentTypeCondition(contentType) {
    switch (contentType) {
      case "vod":
        return {
          meta_schema_id: metaSchemas.episode.id,
          "values.is_live": false,
        };
      case "catchup":
        return {
          meta_schema_id: metaSchemas.episode.id,
          "values.is_live": true,
          "values.catch_up_flag": true,
          time_range: {
            "values.encode_end_date": { lt: "now" },
            delivery_end_at: { gt: "now" },
          },
        };
      case "live":
        return {
          meta_schema_id: metaSchemas.episode.id,
          "values.is_live": true,
          time_range: {
            "values.encode_end_date": { gt: "now" },
          },
        };
      case "episode":
        return {
          meta_schema_id: metaSchemas.episode.id,
        };
      case "channel":
        return { meta_schema_id: metaSchemas.channel.id };
      case "all":
        return {};
    }
  }

  isMaybeLoggedIn() {
    return !!this.context.req?.userToken;
  }

  willSendRequest(_path, request) {
    // IPアドレスをforward
    const remoteIp = getRemoteIpAddress(this.context.req);
    request.headers["X-Forwarded-For"] = remoteIp;
    // UAをプロキシする
    request.headers[
      "User-Agent"
    ] = `${this.context.req?.deviceInfo?.ua} spooxweb`;

    if (this.context.req?.userToken) {
      const { id, accessToken } = this.context.req.userToken;
      request.headers["X-User-Id"] = id;

      request.headers["Authorization"] = `Bearer ${accessToken}`;
      if (
        _path === "/api/v1/metas/dsearch" &&
        request.params instanceof URLSearchParams
      ) {
        request.params.append("user_id", id);
      }
    }

    if (
      _path === "/api/v1/users/existed" ||
      _path === "/api/v1/users/password_update" ||
      _path === "/api/v1/users/regist" ||
      _path === "/api/v1/users/idc/regist"
    ) {
      request.headers["X-Api-Key"] = config.logica.apikey;
    }
    const requestId = uuidv4();
    request.headers["X-Spoox-Web-Logica-Request-Id"] = requestId;
    const requestParams = request.params || null;
    const userId = request.headers["X-User-Id"];

    const operationName = this.context.req?.query?.operationName || "unknown";
    const url = this.context.req?.url || "unknown";

    try {
      // 個人情報をマスクする
      const maskedBody = recurciveMask(request.body);
      const maskedBodyStr = JSON.stringify(maskedBody || null);
      console.log(
        `[${requestId}][Logica][REQUEST INFO] Method: ${request.method}, Path: ${_path}, Params: ${requestParams}, UserId: ${userId}, Body: ${maskedBodyStr}, OperationName: ${operationName}, URL: ${url} `
      );
    } catch (e) {
      // 万が一エラーになってもサービスを止めないようにエラーを潰す
      console.log(e);
    }
  }

  async didReceiveResponse(response, request) {
    const requestId = request.headers["X-Spoox-Web-Logica-Request-Id"];
    const responseBody = await super.didReceiveResponse(response, request);
    const logicaRequestId = responseBody?.request_id;
    console.log(
      `[${requestId}][Logica][RESPONSE INFO] request_id: ${logicaRequestId} Status: ${response.status}`
    );
    return responseBody;
  }
}
export default LogicaAPI;
